module.exports = __webpack_public_path__ + "media/images/games/35gender/flowers-2a8089bdeb113b445107eb8d13a7fda2.png";